module.exports = __webpack_public_path__ + "img/loading.3525654d.gif";